import { styled } from "@mui/material";

export const ModulesContainer = styled("div")(({ theme }) => ({
  width: "100%",
  marginBottom: theme.spacing(4),
}));
